export function validatePhoneNumber(phoneNumber) {
    const regex = /^\+\d{11,14}$/;
    return regex.test(phoneNumber);
}